
import { roll_list } from "@/api";
import { conversion} from "@/tool";

import Picture from '@/components/picture';
import Button from '@/components/button';
import Avatar from '@/components/avatar';
import Award from '@/components/award';
import { CustomBlockTitle } from '@/partials/custom_block_title';
import RoomItem from './components/RoomItem.vue';

import { mapState, mapMutations } from 'vuex';

import Vue from 'vue'
import Vuex from 'vuex'

export default {
	name: 'rolls',

	components: {
		'c-picture': Picture,
		'c-button': Button,
		'c-avatar': Avatar,
		'c-award': Award,
		'p-custom-block-title': CustomBlockTitle,
		'c-RoomItem':RoomItem
	},

	filters: {
		conversion
	},


	data(){ return {
		category: 0,
		rollData:  []
	}; },


	created() {
		this.getList()
	},

	computed: {
		...mapState(["user"]),
	},

	methods: {
		pathGo(obj) {
			this.$router.push(obj);
		   this.$emit('close_button_click');	
	   },	
		switchtab(id){

			if(id== 3){

				if(!this.user.nickname){
					return this.$store.commit('setloginModal',true); 
				}
			}

			this.category = id;
			this.getList();
		},
		getList(page){
			roll_list({type: this.category == 3?1:0,size:999999}).then(res => {
				if(res.data.code === 0){
					this.rollData = res.data.data.data;

					if(this.category == 1){
						this.rollData = this.rollData.filter(_=> _.isOfficial );
					}

					if(this.category == 2){
						this.rollData = this.rollData.filter(_=> !_.isOfficial);
					}

					if(this.category == 4){
						this.rollData = this.rollData.filter(_=> _.state == 1);
					}
				}
			})
		}
	}
}
